<template>
    <div>
        <div v-for="attribute in attributes" :key="attribute.id">
            <b>{{ capitalize(attribute.attribute_name) }}</b>
            <div v-if="attribute.value.value">
                <div v-if="isListType(attribute) && !isCheckboxType(attribute)">
                    <!-- Handle list type attributes -->
                    <div v-for="value in attribute.attributeListValues" :key="value.id">
                        {{ value.attribute_value }}
                    </div>
                </div>
                <div v-else-if="isSignatureType(attribute)">
                    <!-- Handle signature type -->
                    <a :href="attribute.value.value" target="_blank">
                        <img :src="attribute.value.value" class="signature_img">
                    </a>
                </div>
                <div v-else>
                    <!-- Handle other types -->
                    {{ formatValue(attribute.value.value) }}
                </div>
            </div>
            <div v-else>
                No data
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewAttributes",
    props: {
        item: [String, Object],
        itemId: [String, Number],
        attributes: Array,
    },
    methods: {
        capitalize(text) {
            return text;
            // Implement text capitalization
        },
        attributeValueExists(attribute) {
            return attribute.value;
            // Check if attribute value exists
        },
        isListType(attribute) {
            // Determine if attribute is a list type
            return attribute.type.is_list;
        },
        isCheckboxType(attribute) {
            // Determine if attribute is a checkbox type
           return  attribute.type.attribute_type ==='checkbox'

        },
        isSignatureType(attribute) {
            // Determine if attribute is a signature type
            return  attribute.type.attribute_type =='signature'
        },
        getListValues(attribute) {
            // Get list values for attribute
        },
        formatValue(value) {
            // Format the value based on type
            // if (value!==''){
            //     return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
            // }
            return value;
        },
    },
}
</script>

<style scoped>

</style>